import { Toast, ToastProvider } from "@uhg-harmony/react";
import type { FC, ReactNode } from "react";
import styled from "styled-components";
import { useToastStore } from "../store/toastStore";

interface ToastProviderWrapperProps {
  children: ReactNode;
  duration?: number;
  enabled?: boolean;
}

const NotificationToast = styled(Toast)`
  width: min(420px, calc(100vw - 32px));
  max-width: calc(100vw - 32px);

  &,
  * {
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;

const ToastProviderWrapper: FC<ToastProviderWrapperProps> = ({
  children,
  duration = 5000,
  enabled = true,
}) => {
  const {
    toastMessage,
    toastHeader,
    toastVariant,
    isActionToast,
    alignment,
    showToast,
    hideToast,
  } = useToastStore();

  return (
    <ToastProvider>
      {children}
      {(enabled || isActionToast) && showToast && (
        <NotificationToast
          variant={toastVariant as Parameters<typeof Toast>[0]["variant"]}
          alignment={alignment}
          dismissible
          duration={duration}
          announcementPriority="polite"
          onDismiss={hideToast}
          message={toastMessage}
          headerText={toastHeader}
        />
      )}
    </ToastProvider>
  );
};

export { ToastProviderWrapper };
